/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Preview_HiddenInputs */



/**
* | output |
* | --- |
* | "Preview — hidden from customers until turned on" |
*
* @param {Partner_Status_Preview_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_preview_hidden = /** @type {((inputs?: Partner_Status_Preview_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Preview_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau – für Kunden ausgeblendet, bis aktiviert")
	return /** @type {LocalizedString} */ ("Preview — hidden from customers until turned on")
});